import React from "react";
import { useT } from "@transifex/react";
import {
  QuestionnaireGlobalStyle,
  LayoutContainer,
  Header,
  LogoWrapper,
  HeaderActions,
  RestartLink,
  ProgressBarContainer,
  ProgressBarTrack,
  ProgressBarFill,
  ProgressText,
  MainContent,
  Footer,
} from "./styles";
import { Logo } from "../../components/logo";

interface Props {
  children: React.ReactNode;
  progress?: number;
  logoUrl?: string;
  logoMaxHeight?: string;
  showProgress?: boolean;
  showRestart?: boolean;
  onRestart?: () => void;
  languagePicker?: React.ReactNode;
}

const QuestionnaireLayout: React.FC<Props> = ({
  children,
  progress = 0,
  logoUrl,
  logoMaxHeight = "35px",
  showProgress = true,
  showRestart = false,
  onRestart,
  languagePicker,
}) => {
  const t = useT();

  return (
    <LayoutContainer>
      <QuestionnaireGlobalStyle />
      <Header>
        <LogoWrapper>
          {logoUrl ? (
            <img src={logoUrl} alt={t("Logo")} style={{ maxHeight: logoMaxHeight }} />
          ) : (
            <Logo />
          )}
        </LogoWrapper>
        <HeaderActions>
          {showRestart && onRestart && (
            <RestartLink type="button" onClick={onRestart}>
              {t("Start over")}
            </RestartLink>
          )}
          {languagePicker}
        </HeaderActions>
      </Header>
      {showProgress && (
        <ProgressBarContainer>
          <ProgressBarTrack>
            <ProgressBarFill progress={progress} />
          </ProgressBarTrack>
          <ProgressText>{Math.round(progress)}% {t("complete")}</ProgressText>
        </ProgressBarContainer>
      )}
      <MainContent>{children}</MainContent>
      <Footer>
        &copy; {new Date().getFullYear()} CancerIQ. {t("All rights reserved.")}
      </Footer>
    </LayoutContainer>
  );
};

export default QuestionnaireLayout;
